<template>
  <div class="qyxxbgDiaLogBody">
    <div class="_title">
      <p class="_title_info" style="margin: 0 auto">化学品/资质证件变更</p>
    </div>
    <div style="width: 85%; margin: 30px 0 6px 0">
      <el-button
        v-preventReClick
        type="primary"
        icon="el-icon-plus"
        size="mini"
        @click="addMes"
      >新增</el-button>
    </div>
    <el-table
      ref="cktable"
      :data="
        hxpBgjlDtosFu.slice(
          (currentPage - 1) * pagesize,
          currentPage * pagesize
        )
      "
      border
      :show-overflow-tooltip="true"
      :header-cell-style="{ background: '#F2F2F2' }"
      style="width: 85%; margin: 0px auto; z-index: 0"
    >
      <el-table-column align="center" label="化学品名称" prop="hxpmc" />
      <el-table-column align="center" label="业务类型" prop="ywlxLabel" />
      <el-table-column align="center" label="年涉及数量" prop="nsjsl" />
      <el-table-column
        align="center"
        label="年涉及数量单位"
        prop="nsjslDwLabel"
      />
      <el-table-column align="center" label="用途" prop="yt" />
      <el-table-column align="left" label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            v-preventReClick
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
          >编辑</el-button>
          <el-button
            v-preventReClick
            size="mini"
            style="margin-left: 2px"
            type="warning"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager,next,jumper,total,sizes"
      :page-sizes="[10, 20, 30, 40]"
      :total="hxpBgjlDtosFu.length"
      :page-size="pagesize"
      class="el-page"
      :current-page.sync="currentPage"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <div class="_jbxxInfo">
      <div class="_jbxxTitle">变更资质证件</div>
    </div>
    <ul class="uploadzhengjian">
      <li v-for="(item, i) in imgListArray" :key="i" style="margin: 0px 15px">
        <img
          v-preventReClick
          :src="item.imageurl"
          alt=""
          @click="
            imageClick(item.name.split('<').slice(0, 1).toString(), item.zjlx)
          "
        >
        <p v-preventReClick @click="exportMb" v-html="item.html" />
      </li>
    </ul>
    <div class="buttonList">
      <el-button
        v-preventReClick
        class="zsbc"
        @click="save(1)"
      >暂时保存</el-button>
      <el-button
        v-preventReClick
        class="tjsq"
        @click="save(2)"
      >提交申请</el-button>
    </div>
    <!-- 打开许可证弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogFormVisible1"
      center
      custom-class="zhengjiatable"
    >
      <div class="addButton" style="background: #f4f4f4">
        <el-button
          v-preventReClick
          type="primary"
          icon="el-icon-plus"
          size="mini"
          style="background-color: #4170ff; margin: 4px"
          @click="addImageMes"
        >添加</el-button>
      </div>

      <el-table
        :data="imagetableData"
        border
        style="width: 100%"
        max-height="420"
      >
        <el-table-column
          v-for="(item, i) in headerlist"
          :key="i"
          align="center"
          :prop="item.prop"
          :label="item.label"
        />
        <el-table-column label="证件状态" width="120">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-value="0"
              inactive-value="1"
              active-color="#3399FF"
              inactive-color="#CCCCCC"
              :class="{
                'switch-is-actived': scope.row.status === '0',
              }"
              @change="zjStatusChange($event, scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="310px">
          <template slot-scope="scope">
            <el-button
              v-if="haveAdd(scope.row)"
              v-preventReClick
              type="primary"
              icon="el-icon-view"
              size="mini"
              style="background-color: #4170ff; margin-left: 22px"
              @click="editItem(scope.$index, scope.row)"
            >编辑</el-button>
            <el-button
              v-preventReClick
              type="primary"
              icon="el-icon-view"
              size="mini"
              style="background-color: #4170ff; margin-left: 22px"
              @click="handleView(scope.$index, scope.row)"
            >查看</el-button><el-button
              v-if="haveAdd(scope.row)"
              v-preventReClick
              type="primary"
              icon="el-icon-view"
              size="mini"
              style="background-color: #4170ff; margin-left: 22px"
              @click="deleteItem(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 许可证弹窗的弹窗 -->
      <dialog-1
        ref="dialog1"
        :type="type"
        :dialog-form-visible="dialogFormVisible"
        :title="title"
        :zjlx="imagezjlx"
        @close-dialog="closeDialog"
        @getFjTableMess="saveInfomation"
      />
      <!-- 许可证弹窗的弹窗end -->
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="
            background-color: #4170ff;
            width: 90px;
            height: 40px;
            margin-bottom: 20px;
          "
          @click="xkzClose"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!-- 打开许可证弹窗end -->

    <!-- 添加化学品弹窗 -->
    <div>
      <el-dialog
        v-if="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        destroy-on-close
        custom-class="waibu"
        center
      >
        <chemicalPupop :content="content" :puptype="puptype" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import chemicalPupop from '@/components/qyxxbg/qyxxbgHxpPupop'
import dialog1 from '@/components/qyxxbg/qyxxbgDia.vue'
import {
  getBgjlZjlistByZjlx,
  getBgjlZjlistDetail,
  addOrUpdSaveZzzj,
  removeZzzjById,
  changeZzzjStatus,
  getBgjlZzjls
} from '@/assets/js/qyxxbg.js'
export default {
  components: {
    chemicalPupop,
    dialog1
  },
  props: {
    hxpBgjlDtos: [], // 化学品数据
    dwbgjlId: '' // 单位变更id
  },
  data() {
    return {
      imgListArray: [], // 证件列表
      imagezjlx: 0, // 记录当前证件类型 用于后续存储
      headerlist: [], // 字段名列表 用于根据类型展示字段
      imagetableData: [], // 选中的证件数据
      type: true, // 子组件判断 是新增还是查看
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      title: '', // 子组件标题
      isUpdate: false, // 附件信息是否修改  目前标准为只要调用增删改接口就算修改
      activeIndex: Number, // 当前选中的数据index 删除会用到

      haveDwFjlxZl: [], // 已有的证件类型 用于判断证件图片是否有数据的状态   由父组件传递过来
      zjlxList: [], // 证件类型列表  用于判断是否包含某类型    依赖于haveDwFjlxZl
      zjlxs: [], // 如果zjlxList不包含 会加到这个数组中 save方法传递给父组件 表示后端要删除的证件类型数据

      dialogVisible: false, // 化学品弹窗开关
      dialogFormVisible1: false, // 许可证开关
      dialogFormVisible: false // 许可证弹窗的弹窗
    }
  },
  computed: {
    hxpBgjlDtosFu: {
      get() {
        return this.hxpBgjlDtos
      },

      set(val) {
        this.$emit('gethxpBgjlDtos', val)
      }
    }
  },
  watch: {
    hxpBgjlDtosFu: {
      // 化学品改变 判断展示证件照片状态
      handler(curVal, oldVal) {
        this.imageChange()
      },
      deep: true
    },
    haveDwFjlxZl: {
      // 拥有的证件类型改变  判断展示证件照片状态
      handler(curVal, oldVal) {
        this.imageChange()
      },
      deep: true
    },
    isUpdate(curVal, oldVal) {
      // 监听变化  赋值给父组件
      this.$parent.isUpdate = curVal
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 保存编辑数据
    baosunEditData(data) {
      this.dialogVisible = false // 关闭编辑窗口
      // 前端分页  所以保存编辑结果时 应修改当前页中的记录
      this.hxpBgjlDtosFu.slice(
        (this.currentPage - 1) * this.pagesize,
        this.currentPage * this.pagesize
      )[this.activeIndex] = data
      this.$message.success('修改成功')
    },
    // 许可证弹窗关闭
    xkzClose() {
      getBgjlZzjls(this.dwbgjlId).then((e) => {
        this.haveDwFjlxZl = e.data.data // 将获取的资质证件传给子组件3
      })
      this.dialogFormVisible1 = false
    },
    // 有tempAddFlag 可删除 删除的是化学品数据
    handleDelete(index, row) {
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.hxpBgjlDtosFu.filter((item, index) => {
            if (item == row) {
              this.hxpBgjlDtosFu.splice(index, 1)
            }
          })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 下载合法使用需要证明模板
    exportMb(e) {
      if (e.target.innerText.toString() == '下载模板') {
        const link = document.createElement('a')
        link.href = process.env.VUE_APP_PUBLIC_PORT + '/hfsyxyzm.doc'
        link.download = '模板'
        link.click()
      }
    },
    // 保存证件信息
    saveInfomation(val) {
      // 添加附件数据
      addOrUpdSaveZzzj(this.dwbgjlId, val).then((e) => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
        this.isUpdate = true // 将是否修改状态改为 true
        this.getImgtableData() // 刷新列表
      })
    },
    // 获取证件详情接口
    getDetailInfo(row) {
      getBgjlZjlistDetail(row.id).then((e) => {
        // 调用子组件数据初始化方法
        this.$refs.dialog1.csh({
          dwfjDtos: e.data.data.dwfjDtos,
          dwfjSjxxDto: e.data.data.dwfjSjxxDto
        })
      })
    },
    // 查看详情
    handleView(index, row) {
      this.dialogFormVisible = true
      this.type = true
      this.getDetailInfo(row)
    },
    // 编辑详情
    editItem(index, row) {
      this.type = false
      this.dialogFormVisible = true
      this.getDetailInfo(row)
    },
    // 子组件添加化学品数据时调用
    closePupop(data) {
      this.dialogVisible = false
      this.hxpBgjlDtosFu.unshift(data)
    },
    // 打开添加化学品的弹窗
    addImageMes() {
      this.dialogFormVisible = true
      this.type = false
    },
    // 同时校验三个组件的表单并保存
    save(type) {
      var str = []
      this.imgListArray.forEach((element) => {
        // flag为ture  表示该证件信息为必填
        if (element.flag == true) {
          /*
          已有的证件类型 用于判断证件图片是否有数据的状态
          如果不包含当前证件类型  则为false 将对应的证件名称添加到str
          */
          if (this.haveDwFjlxZl.includes(element.zjlx + '') == false) {
            str.push(element.name)
          }
        }
      })
      // str长度大于0   表示有必填证件没有填写  提示用户 不在执行下方的校验
      if (str.length > 0) {
        this.$message.error('请补全' + str.join(',') + '信息')
        return
      }
      this.$parent.todoDelZjlx = this.zjlxs // 传给父组件 需要删除的数据
      this.$emit('validate', (res) => {
        // 调用父组件校验方法  校验三个表单 通过回调函数确定是否可提交
        if (res) {
          this.$bus.emit('qyxxbgSave', type)
        }
      })
    },
    // 点击图片
    imageClick(name, zjlx) {
      this.title = name // 弹框title
      this.imagezjlx = zjlx // 当前证件类型
      this.getFjTableMess(zjlx) // 通过证件类型获取许可证弹窗信息(数据 表头)
      this.dialogFormVisible1 = true // 开启弹窗
    },
    // 调用接口 通过(单位变更id 当前证件类型) 获取数据
    getImgtableData() {
      getBgjlZjlistByZjlx(this.dwbgjlId, this.imagezjlx).then((e) => {
        this.imagetableData = e.data.data
      })
    },
    // 关闭许可证弹窗
    closeDialog() {
      this.dialogFormVisible = false
    },
    // 编辑化学品行数据 index行指针 row此行内容
    handleEdit(index, row) {
      // 展示编辑弹窗
      this.puptype = 'edit' // 操作类型 编辑
      this.content = row // 将行数据传递给子组件
      this.dialogVisible = true // 打开化学品弹窗
      this.activeIndex = index // 当前页 当前数据 下标
      row.unalterable = true // 编辑模式 在化学品弹窗中部分数据不可更改(化学品、业务类型)
    },
    // 判断tempAddFlag状态  决定是否是页面新增的数据
    // 调用接口回显的数据没有此属性也就不可编辑和删除
    haveAdd(row) {
      return row.tempAddFlag
    },
    // 添加行数据
    addMes() {
      this.puptype = 'add' // 操作类型 新增
      this.content = {} // 清空化学品页面数据
      this.dialogVisible = true
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      // 当前页  前端分页只需要改页码
      this.currentPage = val
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
    },
    // 删除的是许可证列表的信息
    deleteItem(index, row) {
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // param1  单位变更id   param2  当前数据id
          removeZzzjById(this.dwbgjlId, row.id).then((e) => {
            this.$message.success('删除成功')
            this.isUpdate = true // 修改状态
            this.getImgtableData() // 刷新列表数据
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 证件状态发生变化 调接口
    zjStatusChange(status, row) {
      changeZzzjStatus(this.dwbgjlId, { id: row.id, status: status }).then(
        (e) => {
          var str = status == '1' ? '关闭成功' : '开启成功'
          this.isUpdate = true // 修改状态
          this.$message.success(str) // 刷新列表数据
        }
      )
    },
    // 获得许可证弹窗信息
    getFjTableMess(zjlx) {
      this.getImgtableData() // 获取数据的方法
      switch (zjlx) {
        case 2: // 非药品类易制毒化学品生产许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'pzcl', label: '生产品种' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'fzjg', label: '发证机关' }
          )
          break
        case 3: // 非药品类易制毒化学品经营许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'tyshxydm', label: '统一社会信用代码' },
            { prop: 'pzcl', label: '经营品种' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break
        case 13: // 非药品类易制毒化学品生产备案证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'pzlb', label: '品种类别' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break
        case 17: // 非药品类易制毒化学品经营备案证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'tyshxydm', label: '统一社会信用代码' },
            { prop: 'pzcl', label: '经营品种' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break
        case 6: // 安全生产许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '主要负责人' },
            { prop: 'jyfw', label: '许可范围' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break

        case 22: // 合法使用需要证明
          this.headerlist = []
          this.headerlist.push(
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'hxpMcs', label: '化学品名称' },
            { prop: 'sjl', label: '涉及量' },
            { prop: 'fzrq', label: '签订日期' }
          )
          break
        case 16: // 危险化学品经营许可
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '单位名称' },
            { prop: 'fzr', label: '单位法定代表人' },
            { prop: 'jyfw', label: '许可范围' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break
        case 12: // 道路运输经营许可
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '业户名称' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break
        case 23: // 其他证件
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zsmc', label: '证书名称' },
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' }
          )
          break
        case 24: // 危险货物道路运输许可证
          this.headerlist = []
          this.headerlist.push(
            { prop: 'zjbh', label: '证件编号' },
            { prop: 'dwmc', label: '业户名称' },
            { prop: 'yxqKs', label: '有效期开始' },
            { prop: 'yxqJs', label: '有效期结束' },
            { prop: 'fzrq', label: '发证日期' }
          )
          break
      }
    },
    // 许可证变化
    imageChange() {
      var zjlxList = this.haveDwFjlxZl // 已有的证件类型 用于判断证件图片是否有数据的状态
      this.imgListArray = []
      this.zjlxs = []
      // 生产类必有
      var res1 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return item.ywlxLabel == '生产'
      })
      res1 == true
        ? this.imgListArray.push({
          zjlx: 6,
          name: '安全生产许可证',
          html: '安全生产许可证',
          imageurl: zjlxList.includes('6')
            ? require('@/assets/img/step41.png')
            : require('@/assets/img/step41_down.png'),
          flag: false
        })
        : this.zjlxs.push('6')
      // 生产1类
      var res2 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return item.ywlxLabel == '生产' && item.hxpLb == '100'
      })
      res2 == true
        ? this.imgListArray.push({
          zjlx: 2,
          name: '非药品类易制毒化学品生产许可证',
          html: "<span style='color: red;'>*</span>非药品类易制毒化学品生产许可证",
          imageurl: zjlxList.includes('2')
            ? require('@/assets/img/step42.png')
            : require('@/assets/img/step42_down.png'),
          flag: true
        })
        : this.zjlxs.push('2')
      // 生产2,3类
      var res3 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return (
          item.ywlxLabel == '生产' &&
          (item.hxpLb == '200' || item.hxpLb == '300')
        )
      })
      res3 == true
        ? this.imgListArray.push({
          zjlx: 13,
          name: '非药品类易制毒化学品生产备案证明',
          html: "<span style='color: red;'>*</span>非药品类易制毒化学品生产备案证明",
          imageurl: zjlxList.includes('13')
            ? require('@/assets/img/step43.png')
            : require('@/assets/img/step43_down.png'),
          flag: true
        })
        : this.zjlxs.push('13')
      var res11 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return item.ywlxLabel == '经营' || item.ywlxLabel == '仓储' // 有一项成员通过就true
      })
      res11 == true
        ? this.imgListArray.push({
          zjlx: 16,
          name: '危险化学品经营许可证',
          html: '危险化学品经营许可证',
          imageurl: zjlxList.includes('16')
            ? require('@/assets/img/step47.png')
            : require('@/assets/img/step47_down.png'),
          flag: false
        })
        : this.zjlxs.push('16')
      // 经营和使用必有
      var res12 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return item.ywlxLabel == '经营' || item.ywlxLabel == '使用' // 有一项成员通过就true
      })
      res12 == true
        ? this.imgListArray.push({
          zjlx: 22,
          name: '合法使用需要证明',
          html: '合法使用需要证明',
          imageurl: zjlxList.includes('22')
            ? require('@/assets/img/step44.png')
            : require('@/assets/img/step44_down.png'),
          flag: false
        })
        : this.zjlxs.push('22')
      // 经营1类
      var res4 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return item.ywlxLabel == '经营' && item.hxpLb == '100'
      })
      res4 == true
        ? this.imgListArray.push({
          zjlx: 3,
          name: '非药品类易制毒化学品经营许可证',
          html: "<span style='color: red;'>*</span>非药品类易制毒化学品经营许可证",
          imageurl: zjlxList.includes('3')
            ? require('@/assets/img/step46.png')
            : require('@/assets/img/step46_down.png'),
          flag: true
        })
        : this.zjlxs.push('3')

      // 经营2和3类
      var res5 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return (
          item.ywlxLabel == '经营' &&
          (item.hxpLb == '200' || item.hxpLb == '300')
        )
      })
      res5 == true
        ? this.imgListArray.push({
          zjlx: 17,
          name: '非药品类易制毒化学品经营备案证明',
          html: "<span style='color: red;'>*</span>非药品类易制毒化学品经营备案证明",
          imageurl: zjlxList.includes('17')
            ? require('@/assets/img/step48.png')
            : require('@/assets/img/step48_down.png'),
          flag: true
        })
        : this.zjlxs.push('17')
      // 运输类
      var res6 = this.hxpBgjlDtosFu.some((item, index, arr) => {
        return item.ywlxLabel === '运输'
      })
      res6 == true
        ? this.imgListArray.push(
          {
            zjlx: 12,
            name: '道路运输经营许可证',
            html: "<span style='color: red;'>*</span>道路运输经营许可证",
            imageurl: zjlxList.includes('12')
              ? require('@/assets/img/step49.png')
              : require('@/assets/img/step49_down.png'),
            flag: true
          },
          {
            zjlx: 24,
            name: '危险货物道路运输许可证',
            html: '危险货物道路运输许可证',
            imageurl: zjlxList.includes('24')
              ? require('@/assets/img/step410.png')
              : require('@/assets/img/step410_down.png'),
            flag: false
          }
        )
        : this.zjlxs.push('12', '24')
      if (this.hxpBgjlDtosFu.length != 0) {
        // 必有  其他证件
        this.imgListArray.push({
          zjlx: 23,
          name: '其他证件',
          html: '其他证件',
          imageurl: zjlxList.includes('23')
            ? require('@/assets/img/step45.png')
            : require('@/assets/img/step45_down.png'),
          flag: false
        })
      }
    }
  }
}
</script>
<style scoped lang='less'>
.qyxxbgDiaLogBody {
  width: 90%;
  max-width: 1200px;
  margin: 10px auto 20px auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  position: relative;
  ._title {
    margin-top: 50px;
    ._title_info {
      height: 30px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
    }
  }
  & > .el-button {
    width: 136px;
    height: 40px;
    font-family: Medium;
    font-size: 13px;
    padding: 0;
  }
  .el-pagination {
    margin-bottom: 44px;
    padding: 10px 0;
    width: 85%;
    border: 1px solid #ebeef5;
    border-top: 0;
  }
  .el-button--warning {
    color: #fff;
    background-color: #ed5e0b;
    border-color: #ed5e0b;
  }
  .el-button--primary {
    color: #fff;
    background-color: #4170ff;
    border-color: #4170ff;
  }
  ._jbxxInfo {
    width: 85%;
    margin-bottom: 30px;
    ._jbxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }

  .uploadzhengjian {
    width: 85%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-left: 0 !important;
    li {
      width: 26%;
      list-style: none;
      text-align: center;
      img {
        width: 202px;
        height: 138px;
      }
      p {
        text-align: center;
        margin: 10px 0 20px;
        span {
          margin-right: 5px;
        }
      }
    }
  }
  .bgzjList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    p {
      width: 169px;
      margin: auto;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #636363;
      line-height: 20px;
    }
  }
  .buttonList {
    text-align: center;
    .zsbc {
      color: #333333;
      width: 148px;
      height: 60px;
      background: #ebebeb;
      border-radius: 5px;
      margin-right: 95px;
      margin-top: 80px;
      margin-bottom: 60px;
    }
    .tjsq {
      color: #ffffff;
      width: 148px;
      height: 60px;
      background: #4170ff;
      border-radius: 5px;
      margin-left: 95px;
      margin-top: 80px;
      margin-bottom: 60px;
    }
  }
}
.zhengjiatable {
  .el-dialog__title {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 0px;
  }

  .el-dialog__body {
    overflow: auto;
  }
  .el-table--border,
  .el-table--group {
    border: 1px solid #ebeef5 !important;
  }
}
.el-switch {
  /deep/ .el-switch__core {
    width: 90px !important;
    &::before {
      content: "证件关闭";
      color: #fff;
      position: absolute;
      transform: scale(0.85);
      left: 20px;
    }
  }
  &.switch-is-actived {
    /deep/ .el-switch__core {
      &::before {
        content: "证件开启";
        left: 5px;
        transform: scale(0.85);
      }
    }
  }
}
</style>
